import React from 'react'
import { formatDate } from 'src/utils'
import { useStyles } from './styles'
import { montaTypes } from 'src/constants/montaType'
import { PregnancyDiagnosisDto } from 'src/dto/pregnancy-diagnosis.dto'
import { CowFaceIcon } from 'src/assets/svg'
import { DiagnosisBadge } from '../../pages/Protected/Reproduction/components/DiagnosisBadge'
import { useNavigate } from 'react-router-dom'
import ROUTES from 'src/constants/routes'

interface ReproductiveCardProps {
  data: PregnancyDiagnosisDto
}

export const ReproductiveCard: React.FC<ReproductiveCardProps> = ({ data }) => {
  const navigate = useNavigate()
  const styles = useStyles()

  const redirectToDiagnosisDetails = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.stopPropagation()

    const url = `${ROUTES.REPRODUCTION.toPregnancyListDetails(data.idFazenda, data.idAnimal, data.idDiagGest)}`
    navigate(url)
  }

  return (
    <div key={data.id} className={styles.historyCard} onClick={redirectToDiagnosisDetails}>
      <div className={styles.historyRowHeader}>
        <span className={styles.reproductionBadge}>{montaTypes[data.tipoReproducao]?.value || '-'}</span>
        <span className={styles.historyDate}>{formatDate(data.dataInicial, false) || '-'}</span>
      </div>

      <div className={styles.historyRowContent}>
        <CowFaceIcon className={styles.historyAnimalNameIcon} />
        <span className={styles.historyAnimalName}>{data.nomeTouro || '-'}</span>
      </div>

      <div className={styles.historyRowContent}>
        {data.listCrias && data.listCrias.length > 0 ? (
          data.listCrias.map((cria) => (
            <DiagnosisBadge
              key={cria.idAnimal}
              label={cria.nome}
              diagnosis={data.diagnostico}
              item={data}
              onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                e.stopPropagation()
                navigate(ROUTES.ANIMAL.toDetails(cria.idAnimal))
              }}
              style={{ cursor: 'pointer' }}
            />
          ))
        ) : (
          <DiagnosisBadge key={data.id} diagnosis={data.diagnostico} item={data} />
        )}
      </div>
    </div>
  )
}
